import React, { useEffect, useState } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Cookies from 'universal-cookie';
import ClipLoader from "react-spinners/ClipLoader";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { Card } from "components/Card/Card.jsx";
import { FetchAPI } from "api/fetch";
import { PostAPI } from "api/post";
import SupportModal from "components/Support/SupportModal";
import "../assets/css/SupportActivities.css"
import swal from "sweetalert";

const Role = () => {
    const cookies = new Cookies();
    const [rowData, setRowData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [isLoader, setIsLoader] = useState({});
    const [filterConfig, setFilterConfig] = useState({});
    const [mapConfig, setMapConfig] = useState({});
    const [filterFormValues, setFilterFormValues] = useState({});
    const [totalRecords, setTotalRecords] = useState(null);
    const [modalParams, setModalParams] = useState({
        modalWidth: "",
        modalTitle: ""
    });
    const [isPageLoader, setIsPageLoader] = useState(true);
    const [permissions, setPermissions] = useState({});
    const logoValMain = require('../../src/assets/img/access-denied.png');
    const [dynamicParameters, setDynamicParameters] = useState({
        user_id: cookies.get('user_id'),
        customer_id: cookies.get('customer_id'),
        userLocation_id: cookies.get('userLocation_id'),
        userRole_name: cookies.get('userRole_name'),
        email: localStorage.getItem("email")
    })
    const [hasError, setHasError] = useState({
        error: false,
        message: ""
    });
    const poFilterFormValues = {
        oldPO: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'Old PO',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'oldPO',
            value: null,
            label: 'Old PO',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        newPO: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'New PO',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'newPO',
            value: null,
            label: 'New PO',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        from_date: {
            elementType: 'from_date',
            elementConfig: {
                placeholder: 'From Date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'from_date',
            value: null,
            label: 'From Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        to_date: {
            elementType: 'to_date',
            elementConfig: {
                placeholder: 'To date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'to_date',
            value: null,
            label: 'To Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
    };
    const locationFilterFormValues = {
        oldPO: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'Old PO',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'oldPO',
            value: null,
            label: 'Old PO',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        oldLocation: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'location',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'oldLocation',
            value: null,
            label: 'Old Location',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        newLocation: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'location',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'newLocation',
            value: null,
            label: 'New Location',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        from_date: {
            elementType: 'from_date',
            elementConfig: {
                placeholder: 'From Date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'from_date',
            value: null,
            label: 'From Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        to_date: {
            elementType: 'to_date',
            elementConfig: {
                placeholder: 'To date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'to_date',
            value: null,
            label: 'To Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
    };
    const eanFilterFormValues = {
        oldPO: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'Old PO',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'oldPO',
            value: null,
            label: 'Old PO',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        oldEAN: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'Old EAN',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'oldEAN',
            value: null,
            label: 'Old EAN',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        newEAN: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'new EAN',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'newEAN',
            value: null,
            label: 'New EAN',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        from_date: {
            elementType: 'from_date',
            elementConfig: {
                placeholder: 'From Date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'from_date',
            value: null,
            label: 'From Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        to_date: {
            elementType: 'to_date',
            elementConfig: {
                placeholder: 'To date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'to_date',
            value: null,
            label: 'To Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
    };
    const vendorFilterFormValues = {
        oldPO: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'Old PO',
                options: [{
                    label: "Please Select",
                    value: null
                }]
            },
            id: 'oldPO',
            value: null,
            label: 'Old PO',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        qty_mode: {
            elementType: 'select',
            elementConfig: {
                placeholder: 'mode',
                options: [
                    {
                        displayValue: "Please Select",
                        value: null
                    }, {
                        displayValue: "Assign",
                        value: "assign"
                    }, {
                        displayValue: "Reclaim",
                        value: "reclaim"
                    }
                ]
            },
            id: 'qty_mode',
            value: null,
            label: 'Mode',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        from_date: {
            elementType: 'from_date',
            elementConfig: {
                placeholder: 'From Date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'from_date',
            value: null,
            label: 'From Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        to_date: {
            elementType: 'to_date',
            elementConfig: {
                placeholder: 'To date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'to_date',
            value: null,
            label: 'To Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
    };

    const unbindFilterFormValues = {
        serial_number: {
            elementType: 'input',
            elementConfig: {
                placeholder: 'Serial Number',
                type: 'text',
            },
            id: 'serial_number',
            value: null,
            label: 'Serial Number',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        dest_location: {
            elementType: 'selectshowsearch',
            elementConfig: {
                placeholder: 'Location',
                options: [
                    {
                        value: null,
                        displayValue: 'Location',
                    },
                ],
            },
            id: 'location',
            value: null,
            label: 'Location',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        from_date: {
            elementType: 'from_date',
            elementConfig: {
                placeholder: 'From Date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'from_date',
            value: null,
            label: 'From Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
        to_date: {
            elementType: 'to_date',
            elementConfig: {
                placeholder: 'To date',
                type: 'date',
                id: 'example-date-input',
            },
            id: 'to_date',
            value: null,
            label: 'To Date',
            validate: {
                required: false,
                rules: 'required',
            },
            update: {
                required: false,
            },
        },
    };

    const unbindMapFormValues = {
        type: {
            elementType: "select",
            elementConfig: {
                placeholder: "Category",
                options: [
                    {
                        displayValue: "Please Select",
                        value: null
                    },
                    {
                        displayValue: "Master Carton",
                        value: "Master Carton"
                    },
                    {
                        displayValue: "Gift Box",
                        value: "Gift Box"
                    }]
            },
            id: "type",
            value: null,
            name: "type",
            checked: false,
            label: "Unbind Category",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        iot: {
            elementType: "textarea",
            elementConfig: {
                placeholder: "Unbind Serial Number",
            },
            id: "textarea",
            value: null,
            label: "Unbind Serial Number",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        inputUser: {
            elementType: "text",
            elementConfig: {
                placeholder: "Operator",
            },
            id: "inputUser",
            value: null,
            label: "Operator",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        }

    }
    const downloadBulkStatusFormValues = {
        vendorId: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Vendor  ID",
                options: [
                    {
                        value: null,
                        displayValue: "Please Select"
                    }]
            },
            id: "vendorId",
            value: null,
            name: "vendorId",
            label: "Select Vendor",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        status: {
            elementType: "checkbox",
            elementConfig: {
                placeholder: "Status",
                type: "checkbox"
            },
            id: "status",
            value: null,
            label: "Status",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        }
    }

    const poMapFormValues = {
        oldPO: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Old PO Number",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                }
                ]
            },
            id: "oldPO",
            value: null,
            label: "Old PO Number",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        newPO: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "New PO Number",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                },
                {
                    value: "PO123",
                    displayValue: "Test"
                }
                ]
            },
            id: "newPO",
            value: null,
            label: "New PO Number",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        inputUser: {
            elementType: "text",
            elementConfig: {
                placeholder: "Operator",
            },
            id: "inputUser",
            value: null,
            label: "Operator",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        partial: {
            elementType: "checkbox",
            elementConfig: {
                placeholder: "Partial",
                type: "checkbox"
            },
            id: "partial",
            value: null,
            label: "Partial",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        file: {
            elementType: "file",
            elementConfig: {
                placeholder: "Upload File",
                type: "file",
                disabled: true,
                accept: ".xls, .xlsx"
            },
            id: "file",
            value: null,
            label: "Upload File",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },

    }

    const locationMapFormValues = {
        oldPO: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "PO Number",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                },
                ]
            },
            id: "oldPO",
            value: null,
            label: "PO Number",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        oldLocation: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Old Location",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                }
                ]
            },
            id: "oldLocation",
            value: null,
            label: "Old Location",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        newLocation: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "New Location",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                }
                ]
            },
            id: "newLocation",
            value: null,
            label: "New Location",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        vendorId: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Vendor ID",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                }
                ]
            },
            id: "vendorId",
            value: null,
            label: "Select Vendor",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        inputUser: {
            elementType: "text",
            elementConfig: {
                placeholder: "Operator",
            },
            id: "inputUser",
            value: null,
            label: "Operator",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        partial: {
            elementType: "checkbox",
            elementConfig: {
                placeholder: "Partial",
                type: "checkbox"
            },
            id: "partial",
            value: null,
            label: "Partial",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        file: {
            elementType: "file",
            elementConfig: {
                placeholder: "Upload File",
                type: "file",
                disabled: true,
                accept: ".xls, .xlsx"
            },
            id: "file",
            value: null,
            label: "Upload File",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },

    }

    const eanMapFormValues = {
        oldPO: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "PO Number",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                },
                ]
            },
            id: "oldPO",
            value: null,
            label: "PO Number",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        oldEAN: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Old EAN",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                }
                ]
            },
            id: "old_ean",
            value: null,
            label: "Old EAN",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        newEAN: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "New EAN",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                },
                ]
            },
            id: "newEAN",
            value: null,
            label: "New EAN",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        inputUser: {
            elementType: "text",
            elementConfig: {
                placeholder: "Operator",
            },
            id: "inputUser",
            value: null,
            label: "Operator",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        partial: {
            elementType: "checkbox",
            elementConfig: {
                placeholder: "Partial",
                type: "checkbox"
            },
            id: "partial",
            value: null,
            label: "Partial",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        file: {
            elementType: "file",
            elementConfig: {
                placeholder: "Upload File",
                type: "file",
                disabled: true,
                accept: ".xls, .xlsx"
            },
            id: "file",
            value: null,
            label: "Upload File",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },

    }
    const vendorQtyMapFormValues = {
        oldPO: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "PO Number",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                },
                ]
            },
            id: "oldPO",
            value: null,
            label: "PO Number",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: true,
                endPoint: "https://login-stg.eseal.io:3003/delivery-creation/get-materialagainstpo",
                method: "GET"
            }
        },
        oldEAN: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Products",
                options: [{
                    value: null,
                    displayValue: "Please Select"
                },
                ]
            },
            id: "oldEAN",
            value: null,
            label: "Products",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: true,
                endPoint: "https://login-stg.eseal.io:3003/supportActivities",
                method: "POST"
            }
        },
        old_used_qty: {
            elementType: "input",
            elementConfig: {
                placeholder: "Old Used Quantity",
                readonly: true
            },
            id: "old_used_qty",
            value: null,
            label: "Old Used Quantity",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        old_pending_qty: {
            elementType: "input",
            elementConfig: {
                placeholder: "Old Pending Quantity",
                readonly: true
            },
            id: "old_pending_qty",
            value: null,
            label: "Old Pending Quantity",
            validate: {
                required: false,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        newUsedQty: {
            elementType: "text",
            elementConfig: {
                placeholder: "New Used Quantity",
            },
            id: "newUsedQty",
            value: null,
            label: "New Used Quantity",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        newPendingQty: {
            elementType: "text",
            elementConfig: {
                placeholder: "New Pending Quantity",
            },
            id: "newPendingQty",
            value: null,
            label: "New Pending Quantity",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        inputUser: {
            elementType: "text",
            elementConfig: {
                placeholder: "Operator",
            },
            id: "inputUser",
            value: null,
            label: "Operator",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
    }
    const piStockInFormValues = {
        file: {
            elementType: "file",
            elementConfig: {
                placeholder: "Upload File",
                type: "file",
                accept: ".xlsx"
            },
            id: "file",
            value: null,
            label: "Upload File",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
        type: {
            elementType: "selectshowsearch",
            elementConfig: {
                placeholder: "Category",
                options: [
                    {
                        displayValue: "Primary",
                        value: "Primary"
                    },
                    {
                        displayValue: "Secondary",
                        value: "Secondary"
                    },
                ]
            },
            id: "type",
            value: null,
            name: "type",
            checked: false,
            label: "Select Type",
            validate: {
                required: true,
                rules: "required",
            },
            update: {
                required: false,
            }
        },
    }

    let activities;
    // if(Object.keys(permissions).length !== 0){
        if(cookies.get("customer_id") == 13){
            activities = [{
                id: 1, title: 'PI Stock In', description: "Provide spreadsheet that includes a list of IDs and their corresponding Locations. This will update the track for PI-Stock.", isView: false, isMap: true, 
                // isPermission: permissions["Support"]["Support Activities"].hasOwnProperty("PO Mapping"), 
                filter: false,
                mapConfig: {
                    formValues: piStockInFormValues,
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                }
            }]
        }else{
        activities = [
            {
                id: 1, title: 'PO Mapping', description: "PO mapping aligns procurement, inventory, and financial systems, ensuring consistency and accuracy. By linking related POs, it streamlines operations, boosts transparency, and optimizes efficiency in the supply chain.", isView: true, isMap: true, 
                // isPermission: permissions["Support"]["Support Activities"].hasOwnProperty("PO Mapping"), 
                gridEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets", filter: false,
                filterConfig: {
                    filter: true,
                    filterFormValues: poFilterFormValues,
                    dropdownMethod: "POST",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    saveEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets",
                    filterExport: true,
                    filterExportApi: "https://login-stg.eseal.io:3005/iotwise_supportGridData"
                },
                mapConfig: {
                    formValues: poMapFormValues,
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    moduleFlag: "pomapping"
                }
            },
            {
                id: 2, title: 'Location Mapping', description: 'Location mapping aligns and synchronizes location data within systems, enabling accurate tracking of physical locations. It enhances inventory management and logistics planning for efficient operations.', isView: true, isMap: true, 
                // isPermission: permissions["Support"]["Support Activities"].hasOwnProperty("Location Mapping"),
                 gridEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets", filter: false,
                filterConfig: {
                    filter: true,
                    filterFormValues: locationFilterFormValues,
                    dropdownMethod: "POST",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    saveEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets",
                    filterExport: true,
                    filterExportApi: "https://login-stg.eseal.io:3005/iotwise_supportGridData"
                },
                mapConfig: {
                    formValues: locationMapFormValues,
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    moduleFlag: "locationmapping"
                }
            },
            {
                id: 3, title: 'EAN Mapping', description: 'EAN mapping involves correlating EAN (European Article Number) or barcode data with corresponding products or items within a system. This process enhances product identification, inventory tracking, and retail operations efficiency.', isView: true, isMap: true, 
                // isPermission: permissions["Support"]["Support Activities"].hasOwnProperty("EAN Mapping"),
                 gridEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets", filter: false,
                filterConfig: {
                    filter: true,
                    filterFormValues: eanFilterFormValues,
                    dropdownMethod: "POST",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    saveEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets",
                    filterExport: true,
                    filterExportApi: "https://login-stg.eseal.io:3005/iotwise_supportGridData"
                },
                mapConfig: {
                    formValues: eanMapFormValues,
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    moduleFlag: "eanmapping"
                }
            },
            {
                id: 4, title: 'Vendor Quantity Mapping', description: 'Change in Purchase Order Quantity: Modification to the quantity of goods or services specified in a purchase order, affecting procurement arrangements and inventory management.', isView: true, isMap: true,
                //  isPermission: permissions["Support"]["Support Activities"].hasOwnProperty("Vendor Qty Update"),
                  gridEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets", filter: false,
                filterConfig: {
                    filter: true,
                    filterFormValues: vendorFilterFormValues,
                    dropdownMethod: "POST",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    saveEndpoint: "https://login-stg.eseal.io:3003/gridrecords/supportTickets",
                    filterExport: true,
                    filterExportApi: "https://login-stg.eseal.io:3005/iotwise_supportGridData"
                },
                mapConfig: {
                    formValues: vendorQtyMapFormValues,
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    moduleFlag: "updateVendorQty"
                }
            },
            {
                id: 5, title: 'Unbind Mapping', description: 'Serial number unbinding is the process of dissociating a specific serial number from a particular device or system, typically to allow for reassignment or transfer to another entity or device.', isView: false, isMap: true,
                //  isPermission: permissions["Support"]["Support Activities"].hasOwnProperty("UnBind Serial Number"),
                  gridEndpoint: "https://login-stg.eseal.io:3003/get-UnbindRecords",
                filterConfig: {
                    filter: true,
                    filterFormValues: unbindFilterFormValues,
                    dropdownMethod: "GET",
                    dropDownApi: "https://login-stg.eseal.io:3003/delivery-creation/get-dropdownvalues",
                    saveEndpoint: "https://login-stg.eseal.io:3003/get-UnbindRecords",
                    filterExport: true,
                    filterExportApi: "https://login-stg.eseal.io:3005/export-UnbindRecords"
                },
                mapConfig: {
                    formValues: {...unbindMapFormValues, bulk:{
                        elementType: "checkbox",
                        elementConfig: {
                            type: "checkbox",
                        },
                        id: "bulk",
                        value: false,
                        label: "Bulk",
                        validate: {
                            required: true,
                            rules: "required"
                        },
                        update: {
                            required: false
                        }
                    }},
                    saveEndpoint: "https://login-stg.eseal.io:3003/unbindserialNumbers",
                    moduleFlag: "unbindMapping"
                }
            },
            {
                id: 6, title: 'Download Bulk Status', description: 'Serial number unbinding is the process of dissociating a specific serial number from a particular device or system, typically to allow for reassignment or transfer to another entity or device.', isView: false, isMap: true,
                  gridEndpoint: "https://login-stg.eseal.io:3003/get-UnbindRecords",
                filterConfig: {
                    filter: true,
                    filterFormValues: unbindFilterFormValues,
                    dropdownMethod: "GET",
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                    filterExport: true,
                    filterExportApi: "https://login-stg.eseal.io:3005/export-UnbindRecords"
                },
                mapConfig: {
                    formValues: {...downloadBulkStatusFormValues},
                    dropDownApi: "https://login-stg.eseal.io:3003/supportActivities",
                    saveEndpoint: "https://login-stg.eseal.io:3003/supportActivities",
                    moduleFlag: "downloadBulkStatus"
                }
            }
        ];
    }
    // }


    const convertToFormData = (payload) => {
        const formData = new FormData();
        for (let key in payload) {
            formData.append(key, payload[key]);
        }
        return formData;
    }

    const getDropDownData = async (endpoint, payload, mapConfig, activity) => {
        setIsLoader(prevState => ({ ...prevState, [`map${activity.id}`]: true, mapStatus: true }));
        const downloadBulkStatusFlag =  mapConfig.moduleFlag === 'downloadBulkStatus'
        if (mapConfig?.dropDownApi !== undefined) {
            const response = await PostAPI(endpoint, payload);
            if (response.status === 200) {
                const result = response?.data?.data;
                for (let identifier in mapConfig.formValues) {
                    if (["newPO", "oldPO"].includes(identifier)) {
                        mapConfig.formValues[identifier].elementConfig.options = result.all_po_number
                    } else if (["oldLocation", "newLocation"].includes(identifier)) {
                        mapConfig.formValues[identifier].elementConfig.options = result.all_locations
                    } else if (["oldEAN", "newEAN"].includes(identifier)) {
                        mapConfig.formValues[identifier].elementConfig.options = result.all_products
                    } else if (["vendorId"].includes(identifier) && !downloadBulkStatusFlag) {
                        mapConfig.formValues[identifier].elementConfig.options = result.all_users
                    }
                    else if (["vendorId"].includes(identifier) && downloadBulkStatusFlag) {
                        mapConfig.formValues[identifier].elementConfig.options = result.bulk_status
                    }
                }
                setShowModal(true);
                setIsLoader(prevState => ({ ...prevState, [`map${activity.id}`]: false, mapStatus: false }));
                setMapConfig(mapConfig)
            } else {
                setIsLoader(prevState => ({ ...prevState, [`map${activity.id}`]: false, mapStatus: false }));
            }
        }
    }

    const handleViewActivity = async (activity) => {
        setIsLoader(prevState => ({ ...prevState, [`view${activity.id}`]: true, viewStatus: true }));
        let start_from = 0;
        let totalParams = { ...dynamicParameters, start_from: start_from, type: activity.mapConfig.moduleFlag };
        let paramsConverted = new URLSearchParams(totalParams);
        const endpoint = (`${activity.gridEndpoint}?${paramsConverted.toString()}`);
        const filterEndpoint = activity.filterConfig.dropdownMethod === "POST" ? activity.filterConfig.dropDownApi : (`${activity.filterConfig.dropDownApi}?${paramsConverted.toString()}`);
        const filterParams = { ...activity.filterConfig, dropDownApi: filterEndpoint, saveEndpoint: activity.filterConfig.saveEndpoint, endpoint }
        const response = await FetchAPI(endpoint);
        const responseJson = await response.json();
        if (response.status === 200) {
            setFilterConfig(filterParams);
            setIsLoader(prevState => ({ ...prevState, [`view${activity.id}`]: false, viewStatus: false }));
            setShowModal(true);
            setRowData(responseJson.data.data);
            setColumns(responseJson.data.columns);
            setShowGrid(true);
            setTotalRecords(responseJson.data.recordsTotal);
            setFilterFormValues(activity.filterConfig.filterFormValues);
            setDynamicParameters((prevState => ({ ...prevState, type: activity.mapConfig.moduleFlag })))
            setModalParams(prevState => ({
                ...prevState,
                modalWidth: responseJson.data.data?.length > 0 ? "modal-90w" : "modal-60w",
                modalTitle: activity.title
            }));
        } else {
            setIsLoader(prevState => ({ ...prevState, [`view${activity.id}`]: false, viewStatus: false }));
        }
    }
    const handleMapActivity = (activity) => {
        setShowGrid(false);
        setMapConfig(activity.mapConfig)
        setModalParams(prevState => ({
            ...prevState,
            modalWidth: "modal-55w",
            modalTitle: activity.title
        }));
        setDynamicParameters((prevState => ({ ...prevState, type: activity.mapConfig.moduleFlag })))
        if(activity.mapConfig.dropDownApi === undefined){
            setShowModal(true);
            return;
        }
        const payloadObj = { type: "fetch_all_po_loc_ean" }
        const payload = convertToFormData(payloadObj);
        getDropDownData(activity.mapConfig.dropDownApi, payload, activity.mapConfig, activity)

    }

    const getActivityRoles = async () => {
        const getURL = "https://login-stg.eseal.io:3003/support_featurePerimssion";
        let totalParams = { ...dynamicParameters };
        let paramsConverted = new URLSearchParams(totalParams);
        const endpoint = (`${getURL}?${paramsConverted.toString()}`);
        const response = await FetchAPI(endpoint)
        if (response.status === 200) {
            const responseJson = await response.json();
            setIsPageLoader(false);
            setPermissions(responseJson.data);
        } else {
            setIsPageLoader(false);
            swal({ icon: "error", title: "Something Went Wrong!" })
        }
    }

    // useEffect(() => {
    //     getActivityRoles()
    // }, [])

    // if (isPageLoader) {
    //     return <div className="text-center"><LoadingSpinner /></div>
    // }
    // else
    const authenticatedUsers = ["eSealSupport@yopmail.com"]
     if (!authenticatedUsers.includes(localStorage.getItem("email"))) {
        return (
            <div className="dynamic-content">
                <Grid fluid>
                    <div className="text-center" style={{ margin: "77px" }}>
                        <img style={{ width: '50px', marginTop: '0px' }} src={logoValMain} alt="logo_image" />
                        <h3 style={{ marginBottom: 10 }} >User dont have permission for support activities</h3>
                        <h5>Please contact admin.</h5>
                    </div>
                </Grid>
            </div>
        );
    }
    return (
        <>
            <div className="content" id="pdfcontent">
                <Grid fluid>
                    <Row>
                        <Col md={12} style={{ marginTop: '0px' }}>
                            <Card style={{ fontSize: '12px' }}
                                title='Support Activities'
                                content={
                                    <>
                                        <div>
                                            <div className="support-card-container">
                                                {activities.length > 0 && activities.map((activity) => (
                                                    <>
                                                        {/* {activity.isPermission &&  */}
                                                        <div className="card common-card" key={activity.id}>
                                                            <h4>{activity.title}</h4>
                                                            <p>{activity.description}</p>
                                                            {(activity.isView || activity.isMap) &&
                                                                <div className="view-map-container" >
                                                                    {activity.isView && <button className="view-button" disabled={isLoader["viewStatus"] ? true : false} onClick={() => handleViewActivity(activity)}>{isLoader[`view${activity.id}`] ? <ClipLoader size={20} color="white" /> : "View"} </button>}
                                                                    {activity.isMap && <button className="view-button" disabled={isLoader["mapStatus"] ? true : false} onClick={() => handleMapActivity(activity)}>{isLoader[`map${activity.id}`] ? <ClipLoader size={20} color="white" /> : "Map"}</button>}
                                                                </div>
                                                            }
                                                        </div>
                                                        {/* } */}
                                                    </>
                                                )
                                                )}
                                            </div>
                                        </div>
                                    </>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
            {showModal &&
                <SupportModal
                    rowData={rowData}
                    columns={columns}
                    setColumns={setColumns}
                    setRowData={setRowData}
                    showGrid={showGrid}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    modalParams={modalParams}
                    isLoader={isLoader}
                    setIsLoader={setIsLoader}
                    filterConfig={filterConfig}
                    mapConfig={mapConfig}
                    filterFormValues={filterFormValues}
                    setFilterFormValues={setFilterFormValues}
                    dynamicParameters={dynamicParameters}
                    totalRecords={totalRecords}
                    setTotalRecords={setTotalRecords}
                    convertToFormData={convertToFormData}
                    setHasError={setHasError}
                />
            }
        </>
    )
}

export default Role;